/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `DAYTIME` - Daytime
 * * `OVERNIGHT` - Overnight
 * * `ANYTIME` - Anytime
 */
export enum ShiftTypeEnum {
    DAYTIME = 'DAYTIME',
    OVERNIGHT = 'OVERNIGHT',
    ANYTIME = 'ANYTIME',
}
